var _g, _g2, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1_169)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 20C46.1634 20 39 27.1634 39 36V204C39 212.837 46.1634 220 55 220H185C193.837 220 201 212.837 201 204V70L151 20H55Z",
    fill: "#4876F9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.303 117.999C117.816 117.999 121.126 118.753 124.256 120.251C126.602 121.358 128.721 122.866 130.628 124.763C132.488 126.609 134.015 128.762 135.141 131.128C133.635 132.636 131.822 133.379 129.703 133.379C128.941 133.375 128.183 133.262 127.452 133.046C126.169 130.966 124.417 129.215 122.337 127.932C119.925 126.447 117.146 125.668 114.313 125.681C112.31 125.681 110.363 126.062 108.483 126.826C106.592 127.597 104.875 128.742 103.437 130.193L91.8922 141.738C90.4406 143.176 89.2948 144.893 88.5234 146.786C87.7682 148.636 87.3793 150.616 87.3784 152.614C87.3784 154.618 87.7609 156.564 88.5234 158.444C89.2889 160.34 90.4355 162.058 91.8922 163.492C93.3297 164.944 95.0468 166.09 96.9397 166.859C98.7897 167.613 100.775 168.004 102.778 168.004C104.782 168.004 106.728 167.623 108.608 166.859C110.5 166.088 112.217 164.943 113.655 163.492L121.737 155.411C124.303 156.107 126.956 156.461 129.703 156.461C130.142 156.461 130.762 156.441 131.563 156.403C131.26 156.738 130.952 157.069 130.638 157.394L119.093 168.939C116.871 171.163 114.352 172.842 111.527 173.987C105.912 176.279 99.622 176.275 94.0097 173.977C91.1757 172.821 88.6028 171.108 86.4434 168.939C84.2209 166.717 82.5422 164.198 81.3972 161.383C80.2618 158.603 79.6785 155.628 79.6797 152.624C79.6797 149.619 80.2609 146.642 81.3972 143.866C82.5422 141.051 84.2209 138.532 86.4434 136.309L97.9884 124.764C98.2084 124.544 98.5422 124.239 98.9809 123.829C101.086 121.949 103.523 120.477 106.166 119.488C108.769 118.513 111.524 118.009 114.303 118.001V117.999ZM141.238 91.0743C144.245 91.0743 147.221 91.6568 149.997 92.7918C152.812 93.9268 155.331 95.6168 157.563 97.8393C159.787 100.062 161.476 102.581 162.611 105.396C163.747 108.176 164.327 111.151 164.318 114.154C164.318 117.159 163.737 120.079 162.592 122.913C161.439 125.745 159.725 128.315 157.555 130.469L146.01 142.014C145.79 142.243 145.456 142.549 145.017 142.949C142.915 144.833 140.478 146.306 137.832 147.291C135.228 148.274 132.468 148.778 129.685 148.778C126.24 148.79 122.838 148.021 119.733 146.528C117.386 145.421 115.267 143.913 113.358 142.016C111.498 140.17 109.972 138.017 108.846 135.651C110.345 134.143 112.158 133.399 114.285 133.399C115.03 133.399 115.783 133.513 116.537 133.733C117.817 135.812 119.564 137.563 121.641 138.847C124.054 140.33 126.833 141.11 129.666 141.098C131.668 141.098 133.616 140.717 135.495 139.953C137.388 139.185 139.105 138.039 140.542 136.586L152.087 125.041C153.541 123.605 154.687 121.887 155.455 119.993C156.208 118.143 156.6 116.168 156.6 114.164C156.6 112.161 156.218 110.214 155.455 108.334C154.686 106.441 153.54 104.724 152.087 103.287C150.65 101.835 148.933 100.689 147.04 99.9193C145.189 99.1648 143.209 98.776 141.21 98.7743C139.206 98.7743 137.26 99.1556 135.381 99.9193C133.487 100.688 131.77 101.834 130.333 103.287L122.242 111.368C119.645 110.666 116.966 110.313 114.276 110.318C113.836 110.318 113.216 110.338 112.415 110.376C112.72 110.042 113.026 109.708 113.35 109.384L124.895 97.8393C127.049 95.6687 129.619 93.9553 132.451 92.8018C135.305 91.6468 138.223 91.0643 141.238 91.0743V91.0743Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.309 65.3125H155.688L201 110.625V70L196.309 65.3125Z",
    fill: "url(#paint0_linear_1_169)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167 70L201 70L151 20L151 54C151 62.8366 158.163 70 167 70Z",
    fill: "#B5C8FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1_169",
    x: 39,
    y: 19,
    width: 162,
    height: 202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_169"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1_169",
    result: "effect2_innerShadow_1_169"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1_169",
    x: 78.6797,
    y: 90.0742,
    width: 93.6406,
    height: 95.6289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_169"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_169",
    result: "effect2_dropShadow_1_169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_169",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_169",
    x1: 165.844,
    y1: 55.1563,
    x2: 211.156,
    y2: 100.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.ce09bae83004ea7a13390270fe4dae9b.svg";
export { ForwardRef as ReactComponent };